import React from 'react';

// functional component(pure component) using destructuring { }, implicit return and default value
const DirectioNewsList = ({ items }) => (
	<div>
		<ul className="news-directio-wrap">
			{items.map(item => (
				<li className="news-item" key={item._id}>
					<div className="news-item-image">
						<img src={item._source.image} alt={item._source.title} className="img-responsive" />
					</div>
					<div className="news-item-content">
						<a className="news-title-link" href={`/area-directio/#/news/${item._id}`} title={item._source.title}>
							<h4 className="news-title">{item._source.title}</h4>
						</a>
						<div className="news-date" data-datelong={item._source.dateIT} />
						<div className="news-description">{item._source.shortDescription}</div>
					</div>
				</li>
			), this)}
		</ul>
		<a href="http://directio.it/multimedia/news.aspx" className="read-more-wrap">
			<i className="material-icons mi-folder"></i>
			<span className="read-more-text">Leggi tutte</span>
		</a>
	</div>
);

DirectioNewsList.propTypes = {
	items: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
};

export default DirectioNewsList;



/** WEBPACK FOOTER **
 ** ./Scripts/libs/components/DirectioNewsList/directioNewsList.js
 **/